import React from "react";

// material ui
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = {
    formControl: {
        minWidth: 120,
        width: "100%"
    },
    selectEmpty: {
        marginTop: "16px",
    },
};

class SelectCountry extends React.Component {

    constructor(props) {
        super(props);

        const countries = [
            { value: "Sweden", label: "Sweden" },
            { value: "France", label: "France" }
        ];

        this.label = props.label ? props.label : "";

        this.state = {
            countries,
            country: countries[0]
        };

        this.resetState = this.resetState.bind(this);
        this.onChangeCountry = this.onChangeCountry.bind(this);
    }

    componentDidMount() {
        const { countries } = this.state;
        const { value } = this.props;

        if (value) {
            const country = countries.find((c) => c.value === value);
            this.setState({ country });
        }
    }

    componentDidUpdate(prevProps) {
        const { countries } = this.state;
        if (this.props.value !== prevProps.value) {

            // find country by value
            const country = countries.find((default_country) => default_country.value === this.props.value);

            this.setState({ country });
        }
    }

    onChangeCountry(event) {
        const country = event.target.value;
        this.setState({ country });

        if (this.props.onChange) {
            this.props.onChange(country.value);
        }
    }

    resetState() {
        this.setState({ country: "" });
    }

    render() {
        const { countries, country } = this.state;
        const { classes } = this.props;

        return (
            <FormControl className={classes.formControl}>
                <InputLabel id="country-select-label">{this.label}</InputLabel>
                <Select
                    labelId="country-select-label"
                    id="country-select"
                    value={country}
                    onChange={this.onChangeCountry}>
                    {countries.map((list_country) => (
                        <MenuItem key={list_country.value} value={list_country}>{list_country.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    }
}

export default withStyles(useStyles)(SelectCountry);
